import { noop } from 'lodash';
import * as ReviewsSelectors from '../reviews';

export const getCallbacks = (state = {}) => state.callbacks;

export const onReviewCreated = (state, commentIds, reviewId, reviewMessage, groupType) => {
    const externalOnReviewCreated = getCallbacks(state).onReviewCreated || Function.prototype;
    const reviewSummary = Array.isArray(commentIds) && commentIds.length > 0 ?
        ReviewsSelectors.getReview(state, commentIds) :
        undefined;

    return Promise.resolve(externalOnReviewCreated(
        reviewSummary,
        reviewId,
        reviewMessage,
        groupType
    ));
};

export const getOnRevisionRejection = (state) => getCallbacks(state).onRevisionRejection || noop;

export const getOnRevisionAcceptanceQuestion = (state) => getCallbacks(state).onRevisionAcceptanceQuestion || noop;

export const getOnResolutionCenterClick = (state) => getCallbacks(state).onResolutionCenterClick || noop;

export const getOnAcceptDeliveryBtnClick = (state) => getCallbacks(state).onAcceptDeliveryBtnClick || noop;
